/* eslint-disable import/group-exports */
/**
 * File generated by the Figma Token Engine
 * Do not edit directly
 */

export const BACKGROUND_LIGHT = "#FFFCF5";
export const BACKGROUND_DARK = "#181E3A";
export const BACKGROUND_DARKER = "#000000";
export const SURFACE_LIGHT = "#FFFBF0";
export const SURFACE_DARK = "#181E3A";
export const SURFACE_DARKER = "#000000";
export const TEXT_LIGHT = "#474643";
export const TEXT_DARK = "#474643";
export const TEXT_DARKER = "#181E3A";
export const TEXT_DARKEST = "#000000";
export const BORDER_LIGHT = "#D0CCC3";
export const BORDER_DARK = "#A3A09A";
export const BORDER_DARKER = "#474643";
export const ERROR_10 = "#2C0908";
export const ERROR_20 = "#4B0F0C";
export const ERROR_30 = "#661411";
export const ERROR_40 = "#841915";
export const ERROR_50 = "#9E1E19";
export const ERROR_60 = "#BC6460";
export const ERROR_70 = "#D6A09E";
export const ERROR_80 = "#EBD1D0";
export const ERROR_90 = "#F8EEED";
export const ERROR_LIGHT = "#F8EEED";
export const ERROR_DARK = "#9E1E19";
export const SUCCESS_10 = "#012002";
export const SUCCESS_20 = "#013803";
export const SUCCESS_30 = "#014B04";
export const SUCCESS_40 = "#016005";
export const SUCCESS_50 = "#007505";
export const SUCCESS_60 = "#56A45A";
export const SUCCESS_70 = "#97C7A9";
export const SUCCESS_80 = "#CAE2CB";
export const SUCCESS_90 = "#EDF5ED";
export const SUCCESS_LIGHT = "#EDF5ED";
export const SUCCESS_DARK = "#007505";
export const WARNING_10 = "#443A01";
export const WARNING_20 = "#6A5901";
export const WARNING_30 = "#957E01";
export const WARNING_40 = "#BA9D01";
export const WARNING_50 = "#E5C100";
export const WARNING_60 = "#EFDA66";
export const WARNING_70 = "#F5E6A9";
export const WARNING_80 = "#FAF2C9";
export const WARNING_90 = "#FDFBEE";
export const WARNING_LIGHT = "#FAF2C9";
export const WARNING_DARK = "#E5C100";
export const WARNING_DARKER = "#957E01";
export const INFO_10 = "#011C36";
export const INFO_20 = "#012F59";
export const INFO_30 = "#01407A";
export const INFO_40 = "#01539E";
export const INFO_50 = "#0065C1";
export const INFO_60 = "#589AD7";
export const INFO_70 = "#99C1E6";
export const INFO_80 = "#D2E4F4";
export const INFO_90 = "#EDF4FB";
export const INFO_LIGHT = "#D2E4F4";
export const INFO_DARK = "#0065C1";
export const INFO_DARKER = "#01407A";
export const BRAND_OFFWHITE = "#FFFBF0";
export const BRAND_HEROYELLOW = "#FFF59B";
export const BRAND_CHARGEYELLOW = "#FCE838";
export const BRAND_CHARGERED = "#EE8C66";
export const BRAND_CHARGEBLUE = "#A5C9FF";
export const BRAND_MEDIUMBLUE = "#49517D";
export const BRAND_HEROBLUE = "#181E3A";
export const BRAND_DAY_HERO =
  "linear-gradient(180deg, #A5C9FF 0%, #FFF59B 100%)";
export const BRAND_DAY_LIGHT =
  "linear-gradient(180deg, #FFFBF0 0%, #FFF59B 100%)";
export const BRAND_DAY_DARK =
  "linear-gradient(180deg, #FFFBF0 0%, #FCE838 100%)";
export const BRAND_DAY_DARKER =
  "linear-gradient(180deg, #FFFBF0 0%, #A5C9FF 100%)";
export const BRAND_DUSK_HERO =
  "linear-gradient(180deg, #E1916E 2%, #7C5959 40.53%, #202645 97.25%)";
export const BRAND_DUSK_LIGHT =
  "linear-gradient(180deg, #FFFBF0 0%, #DD9579 100%)";
export const BRAND_DUSK_DARK =
  "linear-gradient(180deg, #FCEBB1 0%, #DD9579 99.99%, #DD9579 100%)";
export const BRAND_DUSK_DARKER =
  "linear-gradient(180deg, #FFFBF0 0%, #181E3A 100%)";
export const BRAND_NIGHT_HERO =
  "linear-gradient(180deg, #4A517A 2%, #353B5F 33.3%, #202645 97.25%)";
export const BRAND_NIGHT_LIGHT =
  "linear-gradient(180deg, #FFFBF0 0%, #49517D 100%)";
export const BRAND_NIGHT_DARK =
  "linear-gradient(180deg, #49517D 0%, #000000 100%)";
export const BRAND_NIGHT_DARKER =
  "linear-gradient(180deg, #1F2647 0%, #000000 100%)";
export const BRAND_OFF_WHITE = "#fffbf0";
export const BRAND_HERO_BLUE = "#1f2647";
export const BRAND_HERO_YELLOW = "#fff59b";
export const BRAND_CHARGE_YELLOW = "#fce838";
export const BRAND_CHARGE_RED = "#ee8c66";
export const BRAND_CHARGE_BLUE = "#a5c9ff";
export const BRAND_MEDIUM_BLUE = "#49517d";
export const BLACK = "#000000";
export const WHITE = "#ffffff";
export const GRADIENT_DAY_BRAND_HERO =
  "linear-gradient(180deg, #a5c9ff 0%, #fff59b 100%)";
export const GRADIENT_DAY_YELLOW_WHITE =
  "linear-gradient(180deg, #fffbf0 0%, #fff59b 100%)";
export const GRADIENT_DAY_CHARGE_WHITE =
  "linear-gradient(180deg, #fffbf0 0%, #fce838 100%)";
export const GRADIENT_DAY_BLUE_WHITE =
  "linear-gradient(180deg, #fffbf0 0%, #a5c9ff 100%)";
export const GRADIENT_DUSK_BRAND_HERO =
  "linear-gradient(180deg, #e1916e 0%, #7c5959 40.46%, #202645 100%)";
export const GRADIENT_DUSK_RED_YELLOW =
  "linear-gradient(180deg, #fcebb1 0%, #dd9579 99.99%, #dd9579 100%)";
export const GRADIENT_DUSK_RED_WHITE =
  "linear-gradient(180deg, #fffbf0 0%, #dd9579 100%)";
export const GRADIENT_DUSK_BLUE_WHITE =
  "linear-gradient(180deg, #fffbf0 0%, #181e3a 100%)";
export const GRADIENT_NIGHT_NIGHT_HERO =
  "linear-gradient(180deg, #4a517a 0%, #353b5f 32.86%, #202645 100%)";
export const GRADIENT_NIGHT_WHITE_MEDBLUE =
  "linear-gradient(180deg, #fffbf0 0%, #49517d 100%)";
export const GRADIENT_NIGHT_BLACK_MEDBLUE =
  "linear-gradient(180deg, #49517d 0%, #000000 100%)";
export const GRADIENT_NIGHT_BLACK_HEROBLUE =
  "linear-gradient(180deg, #1f2647 0%, #000000 100%)";
export const TINTS_OFF_WHITE_10 = "#474643";
export const TINTS_OFF_WHITE_20 = "#6f6d68";
export const TINTS_OFF_WHITE_30 = "#a3a09a";
export const TINTS_OFF_WHITE_40 = "#d0ccc3";
export const TINTS_OFF_WHITE_50 = "#fffbf0";
export const TINTS_OFF_WHITE_60 = "#fffcf5";
export const TINTS_OFF_WHITE_70 = "#fffdf9";
export const TINTS_OFF_WHITE_80 = "#fffefc";
export const TINTS_OFF_WHITE_90 = "#fffffe";
export const TINTS_HERO_BLUE_10 = "#070911";
export const TINTS_HERO_BLUE_20 = "#0c0e1b";
export const TINTS_HERO_BLUE_30 = "#101426";
export const TINTS_HERO_BLUE_40 = "#141930";
export const TINTS_HERO_BLUE_50 = "#1f2647";
export const TINTS_HERO_BLUE_60 = "#616578";
export const TINTS_HERO_BLUE_70 = "#9fa1ad";
export const TINTS_HERO_BLUE_80 = "#d4d5da";
export const TINTS_HERO_BLUE_90 = "#eff0f2";
export const TINTS_HERO_YELLOW_10 = "#48452c";
export const TINTS_HERO_YELLOW_20 = "#736e46";
export const TINTS_HERO_YELLOW_30 = "#a29c63";
export const TINTS_HERO_YELLOW_40 = "#d1c980";
export const TINTS_HERO_YELLOW_50 = "#fff59b";
export const TINTS_HERO_YELLOW_60 = "#fff8bd";
export const TINTS_HERO_YELLOW_70 = "#fffbd7";
export const TINTS_HERO_YELLOW_80 = "#fffdea";
export const TINTS_HERO_YELLOW_90 = "#fffef9";
export const TINTS_CHARGE_YELLOW_10 = "#464010";
export const TINTS_CHARGE_YELLOW_20 = "#746b1a";
export const TINTS_CHARGE_YELLOW_30 = "#a49825";
export const TINTS_CHARGE_YELLOW_40 = "#d0bf2f";
export const TINTS_CHARGE_YELLOW_50 = "#fce838";
export const TINTS_CHARGE_YELLOW_60 = "#fdf07a";
export const TINTS_CHARGE_YELLOW_70 = "#fef6b1";
export const TINTS_CHARGE_YELLOW_80 = "#fefad5";
export const TINTS_CHARGE_YELLOW_90 = "#fffdf1";
export const TINTS_CHARGE_RED_10 = "#40261c";
export const TINTS_CHARGE_RED_20 = "#714231";
export const TINTS_CHARGE_RED_30 = "#985a41";
export const TINTS_CHARGE_RED_40 = "#c37354";
export const TINTS_CHARGE_RED_50 = "#ee8c66";
export const TINTS_CHARGE_RED_60 = "#f3b197";
export const TINTS_CHARGE_RED_70 = "#f8d2c2";
export const TINTS_CHARGE_RED_80 = "#fce8e0";
export const TINTS_CHARGE_RED_90 = "#fef8f6";
export const TINTS_CHARGE_BLUE_10 = "#2e3746";
export const TINTS_CHARGE_BLUE_20 = "#4c5c74";
export const TINTS_CHARGE_BLUE_30 = "#6a81a4";
export const TINTS_CHARGE_BLUE_40 = "#87a4d0";
export const TINTS_CHARGE_BLUE_50 = "#a5c9ff";
export const TINTS_CHARGE_BLUE_60 = "#c3dbff";
export const TINTS_CHARGE_BLUE_70 = "#dbe9ff";
export const TINTS_CHARGE_BLUE_80 = "#eef5ff";
export const TINTS_CHARGE_BLUE_90 = "#f8fbff";
export const TINTS_MEDIUM_BLUE_10 = "#151723";
export const TINTS_MEDIUM_BLUE_20 = "#22263a";
export const TINTS_MEDIUM_BLUE_30 = "#303551";
export const TINTS_MEDIUM_BLUE_40 = "#3d4367";
export const TINTS_MEDIUM_BLUE_50 = "#49517d";
export const TINTS_MEDIUM_BLUE_60 = "#878daa";
export const TINTS_MEDIUM_BLUE_70 = "#b7bacb";
export const TINTS_MEDIUM_BLUE_80 = "#dbdce5";
export const TINTS_MEDIUM_BLUE_90 = "#f2f3f6";
export const TINTS_ERROR_10 = "#2c0908";
export const TINTS_ERROR_20 = "#4b0f0c";
export const TINTS_ERROR_30 = "#661411";
export const TINTS_ERROR_40 = "#841915";
export const TINTS_ERROR_50 = "#9e1e19";
export const TINTS_ERROR_60 = "#bc6460";
export const TINTS_ERROR_70 = "#d6a09e";
export const TINTS_ERROR_80 = "#ebd1d0";
export const TINTS_ERROR_90 = "#f8eeed";
export const TINTS_SUCCESS_10 = "#012002";
export const TINTS_SUCCESS_20 = "#013803";
export const TINTS_SUCCESS_30 = "#014b04";
export const TINTS_SUCCESS_40 = "#016005";
export const TINTS_SUCCESS_50 = "#007505";
export const TINTS_SUCCESS_60 = "#56a45a";
export const TINTS_SUCCESS_70 = "#97c799";
export const TINTS_SUCCESS_80 = "#cae2cb";
export const TINTS_SUCCESS_90 = "#edf5ed";
export const TINTS_WARNING_10 = "#443a01";
export const TINTS_WARNING_20 = "#6a5901";
export const TINTS_WARNING_30 = "#957e01";
export const TINTS_WARNING_40 = "#ba9d01";
export const TINTS_WARNING_50 = "#e5c100";
export const TINTS_WARNING_60 = "#efda66";
export const TINTS_WARNING_70 = "#f5e69a";
export const TINTS_WARNING_80 = "#faf2c9";
export const TINTS_WARNING_90 = "#fdfbee";
export const TINTS_INFO_10 = "#011c36";
export const TINTS_INFO_20 = "#012f59";
export const TINTS_INFO_30 = "#01407a";
export const TINTS_INFO_40 = "#01539e";
export const TINTS_INFO_50 = "#0065c1";
export const TINTS_INFO_60 = "#589ad7";
export const TINTS_INFO_70 = "#99c1e6";
export const TINTS_INFO_80 = "#d2e4f4";
export const TINTS_INFO_90 = "#edf4fb";
export const FONT_FAMILIES_ROOBERT = "Roobert";
export const FONT_FAMILIES_SF_PRO_TEXT = "SF Pro Text";
export const FONT_FAMILIES_ROBOTO = "Roboto";
export const LINE_HEIGHTS_0 = 310;
export const LINE_HEIGHTS_1 = 220;
export const LINE_HEIGHTS_2 = 280;
export const LINE_HEIGHTS_3 = 120;
export const LINE_HEIGHTS_4 = 104;
export const LINE_HEIGHTS_5 = 96;
export const LINE_HEIGHTS_6 = 80;
export const LINE_HEIGHTS_7 = 72;
export const LINE_HEIGHTS_8 = 64;
export const LINE_HEIGHTS_9 = 44;
export const LINE_HEIGHTS_10 = 36;
export const LINE_HEIGHTS_11 = 32;
export const LINE_HEIGHTS_12 = 24;
export const LINE_HEIGHTS_13 = 20;
export const LINE_HEIGHTS_14 = 30;
export const LINE_HEIGHTS_15 = 22;
export const LINE_HEIGHTS_16 = "100%";
export const LINE_HEIGHTS_17 = 14;
export const FONT_WEIGHTS_ROOBERT_0 = "Regular";
export const FONT_WEIGHTS_ROOBERT_1 = "Medium";
export const FONT_WEIGHTS_SF_PRO_TEXT_2 = "Semibold";
export const FONT_WEIGHTS_SF_PRO_TEXT_3 = "Regular";
export const FONT_WEIGHTS_SF_PRO_TEXT_4 = "Medium";
export const FONT_WEIGHTS_ROBOTO_5 = "Regular";
export const FONT_SIZE_0 = 14;
export const FONT_SIZE_1 = 16;
export const FONT_SIZE_2 = 18;
export const FONT_SIZE_3 = 20;
export const FONT_SIZE_4 = 24;
export const FONT_SIZE_5 = 28;
export const FONT_SIZE_6 = 32;
export const FONT_SIZE_7 = 40;
export const FONT_SIZE_8 = 44;
export const FONT_SIZE_9 = 56;
export const FONT_SIZE_10 = 64;
export const FONT_SIZE_11 = 72;
export const FONT_SIZE_12 = 88;
export const FONT_SIZE_13 = 96;
export const FONT_SIZE_14 = 104;
export const FONT_SIZE_15 = 120;
export const FONT_SIZE_16 = 220;
export const FONT_SIZE_17 = 280;
export const FONT_SIZE_18 = 310;
export const LETTER_SPACING_0 = "-6%";
export const LETTER_SPACING_1 = "-2%";
export const LETTER_SPACING_2 = "-0.09375rem";
export const LETTER_SPACING_3 = "0%";
export const WEB_DISPLAY_XXL_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_XXL_FONT_WEIGHT = "Regular";
export const WEB_DISPLAY_XXL_LINE_HEIGHT = "19.375rem";
export const WEB_DISPLAY_XXL_FONT_SIZE = 310;
export const WEB_DISPLAY_XXL_LETTER_SPACING = "-6%";
export const WEB_DISPLAY_XXL_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_XXL_TEXT_CASE = "none";
export const WEB_DISPLAY_LG_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_LG_FONT_WEIGHT = "Regular";
export const WEB_DISPLAY_LG_LINE_HEIGHT = "13.75rem";
export const WEB_DISPLAY_LG_FONT_SIZE = 220;
export const WEB_DISPLAY_LG_LETTER_SPACING = "-6%";
export const WEB_DISPLAY_LG_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_LG_TEXT_CASE = "none";
export const WEB_DISPLAY_XL_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_XL_FONT_WEIGHT = "Regular";
export const WEB_DISPLAY_XL_LINE_HEIGHT = "17.5rem";
export const WEB_DISPLAY_XL_FONT_SIZE = 280;
export const WEB_DISPLAY_XL_LETTER_SPACING = "-2%";
export const WEB_DISPLAY_XL_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_XL_TEXT_CASE = "none";
export const WEB_DISPLAY_MD_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_MD_FONT_WEIGHT = "Regular";
export const WEB_DISPLAY_MD_LINE_HEIGHT = "7.5rem";
export const WEB_DISPLAY_MD_FONT_SIZE = 120;
export const WEB_DISPLAY_MD_LETTER_SPACING = "-2%";
export const WEB_DISPLAY_MD_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_MD_TEXT_CASE = "none";
export const WEB_DISPLAY_SM_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_SM_FONT_WEIGHT = "Regular";
export const WEB_DISPLAY_SM_LINE_HEIGHT = "6.5rem";
export const WEB_DISPLAY_SM_FONT_SIZE = 104;
export const WEB_DISPLAY_SM_LETTER_SPACING = "-2%";
export const WEB_DISPLAY_SM_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_SM_TEXT_CASE = "none";
export const WEB_DISPLAY_XS_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_XS_FONT_WEIGHT = "Regular";
export const WEB_DISPLAY_XS_LINE_HEIGHT = "6.5rem";
export const WEB_DISPLAY_XS_FONT_SIZE = 96;
export const WEB_DISPLAY_XS_LETTER_SPACING = "-0.09375rem";
export const WEB_DISPLAY_XS_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_XS_TEXT_CASE = "none";
export const WEB_DISPLAY_XXS_FONT_FAMILY = "Roobert";
export const WEB_DISPLAY_XXS_FONT_WEIGHT = "Medium";
export const WEB_DISPLAY_XXS_LINE_HEIGHT = "6rem";
export const WEB_DISPLAY_XXS_FONT_SIZE = 88;
export const WEB_DISPLAY_XXS_LETTER_SPACING = "-2%";
export const WEB_DISPLAY_XXS_PARAGRAPH_INDENT = "0px";
export const WEB_DISPLAY_XXS_TEXT_CASE = "none";
export const WEB_HEADING_XL_FONT_FAMILY = "Roobert";
export const WEB_HEADING_XL_FONT_WEIGHT = "Medium";
export const WEB_HEADING_XL_LINE_HEIGHT = "5rem";
export const WEB_HEADING_XL_FONT_SIZE = 72;
export const WEB_HEADING_XL_LETTER_SPACING = "-2%";
export const WEB_HEADING_XL_PARAGRAPH_INDENT = "0px";
export const WEB_HEADING_XL_TEXT_CASE = "none";
export const WEB_HEADING_LG_FONT_FAMILY = "Roobert";
export const WEB_HEADING_LG_FONT_WEIGHT = "Medium";
export const WEB_HEADING_LG_LINE_HEIGHT = "4.5rem";
export const WEB_HEADING_LG_FONT_SIZE = 64;
export const WEB_HEADING_LG_LETTER_SPACING = "-2%";
export const WEB_HEADING_LG_PARAGRAPH_INDENT = "0px";
export const WEB_HEADING_LG_TEXT_CASE = "none";
export const WEB_HEADING_MD_FONT_FAMILY = "Roobert";
export const WEB_HEADING_MD_FONT_WEIGHT = "Medium";
export const WEB_HEADING_MD_LINE_HEIGHT = "4rem";
export const WEB_HEADING_MD_FONT_SIZE = 56;
export const WEB_HEADING_MD_LETTER_SPACING = "-2%";
export const WEB_HEADING_MD_PARAGRAPH_INDENT = "0px";
export const WEB_HEADING_MD_TEXT_CASE = "none";
export const WEB_HEADING_SM_FONT_FAMILY = "Roobert";
export const WEB_HEADING_SM_FONT_WEIGHT = "Medium";
export const WEB_HEADING_SM_LINE_HEIGHT = "2.75rem";
export const WEB_HEADING_SM_FONT_SIZE = 44;
export const WEB_HEADING_SM_LETTER_SPACING = "-2%";
export const WEB_HEADING_SM_PARAGRAPH_INDENT = "0px";
export const WEB_HEADING_SM_TEXT_CASE = "none";
export const WEB_HEADING_XS_FONT_FAMILY = "Roobert";
export const WEB_HEADING_XS_FONT_WEIGHT = "Regular";
export const WEB_HEADING_XS_LINE_HEIGHT = "2.75rem";
export const WEB_HEADING_XS_FONT_SIZE = 40;
export const WEB_HEADING_XS_LETTER_SPACING = "0%";
export const WEB_HEADING_XS_PARAGRAPH_INDENT = "0px";
export const WEB_HEADING_XS_TEXT_CASE = "none";
export const WEB_HEADING_XXXS_FONT_FAMILY = "Roobert";
export const WEB_HEADING_XXXS_FONT_WEIGHT = "Regular";
export const WEB_HEADING_XXXS_LINE_HEIGHT = "2.25rem";
export const WEB_HEADING_XXXS_FONT_SIZE = 32;
export const WEB_HEADING_XXXS_LETTER_SPACING = "-2%";
export const WEB_HEADING_XXXS_PARAGRAPH_INDENT = "0px";
export const WEB_HEADING_XXXS_TEXT_CASE = "none";
export const WEB_BODY_XXL_FONT_FAMILY = "Roobert";
export const WEB_BODY_XXL_FONT_WEIGHT = "Medium";
export const WEB_BODY_XXL_LINE_HEIGHT = "2.25rem";
export const WEB_BODY_XXL_FONT_SIZE = 28;
export const WEB_BODY_XXL_LETTER_SPACING = "-2%";
export const WEB_BODY_XXL_PARAGRAPH_INDENT = "0px";
export const WEB_BODY_XXL_TEXT_CASE = "none";
export const WEB_BODY_XL_FONT_FAMILY = "Roobert";
export const WEB_BODY_XL_FONT_WEIGHT = "Medium";
export const WEB_BODY_XL_LINE_HEIGHT = "2rem";
export const WEB_BODY_XL_FONT_SIZE = 24;
export const WEB_BODY_XL_LETTER_SPACING = "-2%";
export const WEB_BODY_XL_PARAGRAPH_INDENT = "0px";
export const WEB_BODY_XL_TEXT_CASE = "none";
export const WEB_BODY_LG_FONT_FAMILY = "Roobert";
export const WEB_BODY_LG_FONT_WEIGHT = "Regular";
export const WEB_BODY_LG_LINE_HEIGHT = "1.5rem";
export const WEB_BODY_LG_FONT_SIZE = 20;
export const WEB_BODY_LG_LETTER_SPACING = "-2%";
export const WEB_BODY_LG_PARAGRAPH_INDENT = "0px";
export const WEB_BODY_LG_TEXT_CASE = "none";
export const WEB_BODY_MD_FONT_FAMILY = "Roobert";
export const WEB_BODY_MD_FONT_WEIGHT = "Medium";
export const WEB_BODY_MD_LINE_HEIGHT = "1.5rem";
export const WEB_BODY_MD_FONT_SIZE = 16;
export const WEB_BODY_MD_LETTER_SPACING = "-2%";
export const WEB_BODY_MD_PARAGRAPH_INDENT = "0px";
export const WEB_BODY_MD_TEXT_CASE = "none";
export const WEB_BODY_SM_FONT_FAMILY = "Roobert";
export const WEB_BODY_SM_FONT_WEIGHT = "Medium";
export const WEB_BODY_SM_LINE_HEIGHT = "1.25rem";
export const WEB_BODY_SM_FONT_SIZE = 14;
export const WEB_BODY_SM_LETTER_SPACING = "-2%";
export const WEB_BODY_SM_PARAGRAPH_INDENT = "0px";
export const WEB_BODY_SM_TEXT_CASE = "none";
export const WEB_LABEL_SM_FONT_FAMILY = "SF Pro Text";
export const WEB_LABEL_SM_FONT_WEIGHT = "Semibold";
export const WEB_LABEL_SM_LINE_HEIGHT = "1.25rem";
export const WEB_LABEL_SM_FONT_SIZE = 16;
export const WEB_LABEL_SM_LETTER_SPACING = "-2%";
export const WEB_LABEL_SM_PARAGRAPH_INDENT = "0px";
export const WEB_LABEL_SM_TEXT_CASE = "none";
export const IOS_HEADING_LG_FONT_FAMILY = "SF Pro Text";
export const IOS_HEADING_LG_FONT_WEIGHT = "Regular";
export const IOS_HEADING_LG_LINE_HEIGHT = "2.25rem";
export const IOS_HEADING_LG_FONT_SIZE = 32;
export const IOS_HEADING_LG_LETTER_SPACING = "0%";
export const IOS_HEADING_LG_PARAGRAPH_INDENT = "0px";
export const IOS_HEADING_LG_TEXT_CASE = "none";
export const IOS_HEADING_MD_FONT_FAMILY = "SF Pro Text";
export const IOS_HEADING_MD_FONT_WEIGHT = "Regular";
export const IOS_HEADING_MD_LINE_HEIGHT = "1.875rem";
export const IOS_HEADING_MD_FONT_SIZE = 24;
export const IOS_HEADING_MD_LETTER_SPACING = "0%";
export const IOS_HEADING_MD_PARAGRAPH_INDENT = "0px";
export const IOS_HEADING_MD_TEXT_CASE = "none";
export const IOS_HEADING_SM_FONT_FAMILY = "SF Pro Text";
export const IOS_HEADING_SM_FONT_WEIGHT = "Medium";
export const IOS_HEADING_SM_LINE_HEIGHT = "1.875rem";
export const IOS_HEADING_SM_FONT_SIZE = 18;
export const IOS_HEADING_SM_LETTER_SPACING = "0%";
export const IOS_HEADING_SM_PARAGRAPH_INDENT = "0px";
export const IOS_HEADING_SM_TEXT_CASE = "none";
export const IOS_BODY_LG_FONT_FAMILY = "SF Pro Text";
export const IOS_BODY_LG_FONT_WEIGHT = "Regular";
export const IOS_BODY_LG_LINE_HEIGHT = "1.375rem";
export const IOS_BODY_LG_FONT_SIZE = 16;
export const IOS_BODY_LG_LETTER_SPACING = "0%";
export const IOS_BODY_LG_PARAGRAPH_INDENT = "0px";
export const IOS_BODY_LG_TEXT_CASE = "none";
export const IOS_BODY_MD_FONT_FAMILY = "SF Pro Text";
export const IOS_BODY_MD_FONT_WEIGHT = "Regular";
export const IOS_BODY_MD_LINE_HEIGHT = "1.25rem";
export const IOS_BODY_MD_FONT_SIZE = 14;
export const IOS_BODY_MD_LETTER_SPACING = "-2%";
export const IOS_BODY_MD_PARAGRAPH_INDENT = "0px";
export const IOS_BODY_MD_TEXT_CASE = "none";
export const IOS_BODY_SM_FONT_FAMILY = "SF Pro Text";
export const IOS_BODY_SM_FONT_WEIGHT = "Regular";
export const IOS_BODY_SM_LINE_HEIGHT = "100%";
export const IOS_BODY_SM_FONT_SIZE = 14;
export const IOS_BODY_SM_LETTER_SPACING = "0%";
export const IOS_BODY_SM_PARAGRAPH_INDENT = "0px";
export const IOS_BODY_SM_TEXT_CASE = "none";
export const IOS_BODY_XS_FONT_FAMILY = "SF Pro Text";
export const IOS_BODY_XS_FONT_WEIGHT = "Regular";
export const IOS_BODY_XS_LINE_HEIGHT = "100%";
export const IOS_BODY_XS_FONT_SIZE = 14;
export const IOS_BODY_XS_LETTER_SPACING = "0%";
export const IOS_BODY_XS_PARAGRAPH_INDENT = "0px";
export const IOS_BODY_XS_TEXT_CASE = "none";
export const ANDROID_HEADING_LG_FONT_FAMILY = "Roboto";
export const ANDROID_HEADING_LG_FONT_WEIGHT = "Regular";
export const ANDROID_HEADING_LG_LINE_HEIGHT = "2.25rem";
export const ANDROID_HEADING_LG_FONT_SIZE = 32;
export const ANDROID_HEADING_LG_LETTER_SPACING = "0%";
export const ANDROID_HEADING_LG_PARAGRAPH_INDENT = "0px";
export const ANDROID_HEADING_LG_TEXT_CASE = "none";
export const ANDROID_HEADING_MD_FONT_FAMILY = "Roboto";
export const ANDROID_HEADING_MD_FONT_WEIGHT = "Regular";
export const ANDROID_HEADING_MD_LINE_HEIGHT = "1.875rem";
export const ANDROID_HEADING_MD_FONT_SIZE = 24;
export const ANDROID_HEADING_MD_LETTER_SPACING = "0%";
export const ANDROID_HEADING_MD_PARAGRAPH_INDENT = "0px";
export const ANDROID_HEADING_MD_TEXT_CASE = "none";
export const ANDROID_HEADING_SM_FONT_FAMILY = "Roboto";
export const ANDROID_HEADING_SM_FONT_WEIGHT = "Regular";
export const ANDROID_HEADING_SM_LINE_HEIGHT = "1.875rem";
export const ANDROID_HEADING_SM_FONT_SIZE = 18;
export const ANDROID_HEADING_SM_LETTER_SPACING = "0%";
export const ANDROID_HEADING_SM_PARAGRAPH_INDENT = "0px";
export const ANDROID_HEADING_SM_TEXT_CASE = "none";
export const ANDROID_BODY_MD_FONT_FAMILY = "Roboto";
export const ANDROID_BODY_MD_FONT_WEIGHT = "Regular";
export const ANDROID_BODY_MD_LINE_HEIGHT = "1.375rem";
export const ANDROID_BODY_MD_FONT_SIZE = 16;
export const ANDROID_BODY_MD_LETTER_SPACING = "0%";
export const ANDROID_BODY_MD_PARAGRAPH_INDENT = "0px";
export const ANDROID_BODY_MD_TEXT_CASE = "none";
export const ANDROID_BODY_SM_FONT_FAMILY = "Roboto";
export const ANDROID_BODY_SM_FONT_WEIGHT = "Regular";
export const ANDROID_BODY_SM_LINE_HEIGHT = "0.875rem";
export const ANDROID_BODY_SM_FONT_SIZE = 14;
export const ANDROID_BODY_SM_LETTER_SPACING = "0%";
export const ANDROID_BODY_SM_PARAGRAPH_INDENT = "0px";
export const ANDROID_BODY_SM_TEXT_CASE = "none";
export const TEXT_CASE_NONE = "none";
export const PARAGRAPH_INDENT_0 = "0px";
export const OFFWHITE_10 = "#474643";
export const OFFWHITE_20 = "#474643";
export const OFFWHITE_30 = "#A3A09A";
export const OFFWHITE_40 = "#D0CCC3";
export const OFFWHITE_50 = "#FFFBF0";
export const OFFWHITE_60 = "#FFFCF5";
export const OFFWHITE_70 = "#FFFDF9";
export const OFFWHITE_80 = "#FFFEFC";
export const OFFWHITE_90 = "#FFFFFE";
export const HEROYELLOW_10 = "#48452C";
export const HEROYELLOW_20 = "#736E46";
export const HEROYELLOW_30 = "#A29C63";
export const HEROYELLOW_40 = "#D1C980";
export const HEROYELLOW_50 = "#FFF59B";
export const HEROYELLOW_60 = "#FFF8BD";
export const HEROYELLOW_70 = "#FFFBD7";
export const HEROYELLOW_80 = "#FFFDEA";
export const HEROYELLOW_90 = "#FFFEF9";
export const CHARGEYELLOW_10 = "#464010";
export const CHARGEYELLOW_20 = "#746B1A";
export const CHARGEYELLOW_30 = "#A49825";
export const CHARGEYELLOW_40 = "#D0BF2F";
export const CHARGEYELLOW_50 = "#FCE838";
export const CHARGEYELLOW_60 = "#FDF07A";
export const CHARGEYELLOW_70 = "#FEF6B1";
export const CHARGEYELLOW_80 = "#FFFDEA";
export const CHARGEYELLOW_90 = "#FFFDF1";
export const CHARGERED_10 = "#40261C";
export const CHARGERED_20 = "#714231";
export const CHARGERED_30 = "#985A41";
export const CHARGERED_40 = "#C37354";
export const CHARGERED_50 = "#EE8C66";
export const CHARGERED_60 = "#F3B197";
export const CHARGERED_70 = "#F8D2C2";
export const CHARGERED_80 = "#FCE8E0";
export const CHARGERED_90 = "#FEF8F6";
export const CHARGEBLUE_10 = "#2E3746";
export const CHARGEBLUE_20 = "#4C5C74";
export const CHARGEBLUE_30 = "#6A81A4";
export const CHARGEBLUE_40 = "#87A4D0";
export const CHARGEBLUE_50 = "#A5C9FF";
export const CHARGEBLUE_60 = "#C3DBFF";
export const CHARGEBLUE_70 = "#DBE9FF";
export const CHARGEBLUE_80 = "#EEF5FF";
export const CHARGEBLUE_90 = "#F8FBFF";
export const MEDIUMBLUE_10 = "#151723";
export const MEDIUMBLUE_20 = "#22263A";
export const MEDIUMBLUE_30 = "#22263A";
export const MEDIUMBLUE_40 = "#3D4367";
export const MEDIUMBLUE_50 = "#49517D";
export const MEDIUMBLUE_60 = "#878DAA";
export const MEDIUMBLUE_70 = "#B7BACB";
export const MEDIUMBLUE_80 = "#DBDCE5";
export const MEDIUMBLUE_90 = "#F2F3F6";
export const HEROBLUE_10 = "#070911";
export const HEROBLUE_20 = "#0C0E1B";
export const HEROBLUE_30 = "#101426";
export const HEROBLUE_40 = "#141930";
export const HEROBLUE_50 = "#181E3A";
export const HEROBLUE_60 = "#616578";
export const HEROBLUE_70 = "#9FA1AD";
export const HEROBLUE_80 = "#D4D5DA";
export const HEROBLUE_90 = "#EFF0F2";
export const DAY_YELLOW_WHITE =
  "linear-gradient(180deg, #FFFBF0 0%, #FFF59B 100%)";
export const DAY_CHARGE_WHITE =
  "linear-gradient(180deg, #FFFBF0 0%, #FCE838 100%)";
export const DAY_HERO = "linear-gradient(180deg, #A5C9FF 0%, #FFF59B 100%)";
export const DAY_BLUE_WHITE =
  "linear-gradient(180deg, #FFFBF0 0%, #A5C9FF 100%)";
export const DUSK_RED_WHITE =
  "linear-gradient(180deg, #FFFBF0 0%, #DD9579 100%)";
export const DUSK_RED_YELLOW =
  "linear-gradient(180deg, #FCEBB1 0%, #DD9579 99.99%, #DD9579 100%)";
export const DUSK_HERO =
  "linear-gradient(180deg, #E1916E 2%, #7C5959 40.53%, #202645 97.25%)";
export const DUSK_BLUE_WHITE =
  "linear-gradient(180deg, #FFFBF0 0%, #181E3A 100%)";
export const NIGHT_WHITE_BLUE =
  "linear-gradient(180deg, #FFFBF0 0%, #49517D 100%)";
export const NIGHT_HERO =
  "linear-gradient(180deg, #4A517A 2%, #353B5F 33.3%, #202645 97.25%)";
export const NIGHT_BLACK_BLUE =
  "linear-gradient(180deg, #49517D 0%, #000000 100%)";
export const NIGHT_BLACK_HERO =
  "linear-gradient(180deg, #1F2647 0%, #000000 100%)";
export const ROOBERT = "Roobert";
export const DISPLAY_LG_FONT_FAMILY = "Roobert";
export const DISPLAY_LG_FONT_WEIGHT = "Regular";
export const DISPLAY_LG_LINE_HEIGHT = "6.5rem";
export const DISPLAY_LG_FONT_SIZE = 104;
export const DISPLAY_LG_LETTER_SPACING = "-2%";
export const DISPLAY_MD_FONT_FAMILY = "Roobert";
export const DISPLAY_MD_FONT_WEIGHT = "Regular";
export const DISPLAY_MD_FONT_SIZE = 88;
export const DISPLAY_MD_LINE_HEIGHT = "6rem";
export const DISPLAY_MD_LETTER_SPACING = "-2%";
export const DISPLAY_SM_FONT_FAMILY = "Roobert";
export const DISPLAY_SM_FONT_WEIGHT = "Regular";
export const DISPLAY_SM_FONT_SIZE = 72;
export const DISPLAY_SM_LINE_HEIGHT = "5rem";
export const DISPLAY_SM_LETTER_SPACING = "-4%";
export const HEADING_LG_FONT_FAMILY = "Roobert";
export const HEADING_LG_FONT_WEIGHT = "Regular";
export const HEADING_LG_LINE_HEIGHT = "3.75rem";
export const HEADING_LG_FONT_SIZE = 54;
export const HEADING_LG_LETTER_SPACING = "-2%";
export const HEADING_MD_FONT_FAMILY = "Roobert";
export const HEADING_MD_FONT_WEIGHT = "Regular";
export const HEADING_MD_FONT_SIZE = 44;
export const HEADING_MD_LINE_HEIGHT = "2.75rem";
export const HEADING_MD_LETTER_SPACING = "-2%";
export const HEADING_SM_FONT_FAMILY = "Roobert";
export const HEADING_SM_FONT_WEIGHT = "Regular";
export const HEADING_SM_LINE_HEIGHT = "2.25rem";
export const HEADING_SM_FONT_SIZE = 32;
export const HEADING_SM_LETTER_SPACING = "-2%";
export const BODY_XXL_FONT_FAMILY = "Roobert";
export const BODY_XXL_FONT_WEIGHT = "Regular";
export const BODY_XXL_LINE_HEIGHT = "2.25rem";
export const BODY_XXL_FONT_SIZE = 28;
export const BODY_XXL_LETTER_SPACING = "-2%";
export const BODY_XL_FONT_FAMILY = "Roobert";
export const BODY_XL_FONT_WEIGHT = "Regular";
export const BODY_XL_LINE_HEIGHT = "2rem";
export const BODY_XL_FONT_SIZE = 24;
export const BODY_XL_LETTER_SPACING = "-2%";
export const BODY_XL_MEDIUM_FONT_FAMILY = "Roobert";
export const BODY_XL_MEDIUM_FONT_WEIGHT = "Medium";
export const BODY_XL_MEDIUM_LINE_HEIGHT = "2rem";
export const BODY_XL_MEDIUM_FONT_SIZE = 24;
export const BODY_XL_MEDIUM_LETTER_SPACING = "-2%";
export const BODY_LG_FONT_FAMILY = "Roobert";
export const BODY_LG_FONT_WEIGHT = "Regular";
export const BODY_LG_LINE_HEIGHT = "1.5rem";
export const BODY_LG_FONT_SIZE = 20;
export const BODY_LG_LETTER_SPACING = "-2%";
export const BODY_LG_MEDIUM_FONT_FAMILY = "Roobert";
export const BODY_LG_MEDIUM_FONT_WEIGHT = "Medium";
export const BODY_LG_MEDIUM_LINE_HEIGHT = "1.5rem";
export const BODY_LG_MEDIUM_FONT_SIZE = 20;
export const BODY_LG_MEDIUM_LETTER_SPACING = "-2%";
export const BODY_MD_FONT_FAMILY = "Roobert";
export const BODY_MD_FONT_WEIGHT = "Regular";
export const BODY_MD_LINE_HEIGHT = "1.5rem";
export const BODY_MD_FONT_SIZE = 16;
export const BODY_MD_LETTER_SPACING = "-2%";
export const BODY_SM_FONT_FAMILY = "Roobert";
export const BODY_SM_FONT_WEIGHT = "Regular";
export const BODY_SM_LINE_HEIGHT = "1.25rem";
export const BODY_SM_FONT_SIZE = 14;
export const BODY_SM_LETTER_SPACING = "-2%";
export const BODY_SM_MEDIUM_FONT_FAMILY = "Roobert";
export const BODY_SM_MEDIUM_FONT_WEIGHT = "Medium";
export const BODY_SM_MEDIUM_LINE_HEIGHT = "1.25rem";
export const BODY_SM_MEDIUM_FONT_SIZE = 14;
export const BODY_SM_MEDIUM_LETTER_SPACING = "-2%";
export const LABEL_MD_FONT_FAMILY = "Roobert";
export const LABEL_MD_FONT_WEIGHT = "Regular";
export const LABEL_MD_LINE_HEIGHT = "1.25rem";
export const LABEL_MD_FONT_SIZE = 12;
export const LABEL_MD_LETTER_SPACING = "0rem";
export const REGULAR = "Regular";
export const MEDIUM = "Medium";
